import axios from "axios";
import { Fragment, useEffect, useState } from "react";
import CustomTable from "../../../../components/CustomTable";

const UserInvoices = ({ user }) => {
  const [userInvoices, setUserInvoices] = useState([]);
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (_, record) => <span>{record?.billing_details?.name}</span>,
    },
    {
      title: "Email",
      dataIndex: "email",
      render: (_, record) => <span>{record?.billing_details?.email}</span>,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      className: "url-col",
      render: (_, record) => {
        const currency = record?.currency?.toUpperCase() || "";
        const amountInDollars = (record?.amount / 100).toFixed(2);
        return `${currency} ${amountInDollars}`;
      },
    },
    {
      title: "Status",
      dataIndex: "status",
    },
    {
      title: "Paid",
      dataIndex: "paid",
      render: (paid) => paid?.toString(),
    },

    {
      title: "Created",
      dataIndex: "created",
      className: "url-col",
      render: (created) => new Date(created * 1000).toLocaleString(),
    },
    {
      title: "Invoice URL",
      dataIndex: "receipt_url",
      className: "url-col",
      render: (receipt_url) => (
        <a
          href={receipt_url}
          rel="noreferrer"
          target="_blank"
          title={receipt_url}
        >
          See invoice
        </a>
      ),
    },
  ];

  const getUserInvoices = async () => {
    try {
      setLoading(true);
      const BASE_URL = process.env.REACT_APP_BASE_API;
      let response = await axios.get(
        `${BASE_URL}payment/customer/${user?.strip_cs_id}`
      );
      const charges = response?.data?.data?.charges?.data || [];
      setUserInvoices(charges);
    } catch (error) {
      console.log("Error fetching user invoices:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user && user?.strip_cs_id) getUserInvoices();
  }, [user]);

  return (
    <Fragment>
      <CustomTable
        dataSource={userInvoices}
        columns={columns}
        loading={loading}
      />
    </Fragment>
  );
};

export default UserInvoices;
